import { Close } from "@mui/icons-material";
import { IconButton, type SnackbarProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

import { StyledSnackbar } from "./Snackbar.sc";

interface Snackbar extends SnackbarProps {
    handleClose: () => void;
    variant: "success" | "error";
}
const Snackbar: FC<PropsWithChildren<Snackbar>> = ({ handleClose, variant, ...props }) => (
    <StyledSnackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={5000}
        action={
            <IconButton size="small" onClick={handleClose}>
                <Close />
            </IconButton>
        }
        $variant={variant}
        {...props}
    />
);

export default Snackbar;
